import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { initialState } from './initialState';
import type { SelectedChild } from '../types/children.types';

const childrenSlice = createSlice({
  initialState,
  name: 'Children',
  reducers: {
    setSelectedChildDetails(state, action: PayloadAction<SelectedChild>) {
      state.selectedChild.ageInMonths = action.payload.ageInMonths;
      state.selectedChild.dob = action.payload.dob;
      state.selectedChild.gender = action.payload.gender;
    },
  },
});

export const { actions: childrenAction } = childrenSlice;

export default childrenSlice.reducer;
